<template>
  <v-row>
    <v-col cols="12">
      <h4 class="social-title text-uppercase text-center letter-spacing mb-3">
        Elige un método rápido de registro
      </h4>
      <v-flex xs12>
        <v-layout justify-center class="button-container">
          <!-- <v-btn
            rounded
            color="#3b5999"
            dark
            class="button-social"
            @click="login('facebook')"
          >
            <v-icon class="mr-1">mdi-facebook</v-icon>
            Registro con facebook
          </v-btn> -->
          <v-btn
            rounded
            color="#FFF"
            class="button-social"
            @click="login('google')"
          >
            <v-icon class="mr-1">mdi-google-plus</v-icon>
            Registro con google
          </v-btn>
        </v-layout>
      </v-flex>
    </v-col>
  </v-row>
</template>

<script>
import datalayerService from "../../services/datalayer";

export default {
  name: 'socialButtons',
  props: {
    height: {
      type: Number,
      default: 0
    },
    register: {
      type: Boolean,
      default: false 
    }
  },
  data: () => ({}),
  methods: {
    dataLayer(app){
        window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'Register 1 Falkon',
            'eventLabel': app,
            'step': '1',
          });
    },
    login(app) {
      // this.$emit('dataLayer', app); // Emit info to trigger datalayer
      if(this.register) {
        this.dataLayer(app);
        datalayerService.registerStep0Social();
      } // Emit info to trigger datalayer
      
      const w = 700;
      const h = this.height > 0 ? this.height / 2 : 400;
      const dualScreenLeft =
        window.screenLeft != undefined ? window.screenLeft : screen.left;
      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
      const left = width / 2 - w / 2 + dualScreenLeft;
      const top = this.height / 3;
      const windowSocial = window.open(
        `${process.env.VUE_APP_API_URL}/channel/api/auth/${app}`,
        "popup",
        `scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`
      );
      if (windowSocial.opener) {
        windowSocial.opener.onmessage = (event) => {
          if (event.data && event.data.auth) {
            const { token, tokenRefresh, complete } = event.data.auth
            if (token && tokenRefresh) {
              this.$store.commit('SET_USER_TOKEN', token)
              this.$store.commit('SET_USER_REFRESHTOKEN', tokenRefresh)
            } else {
              this.$store.commit('SET_USER_TOKEN', token)
              this.$store.commit('SET_USER_TOKEN', tokenRefresh)
            }
            this.$store.commit('AUTH_STATUS_CHANGE', true)
            this.$store.dispatch('profileComplete', event.data.auth.complete)
            this.$router.push({ name: complete == "true" ? "home" : "profile" });
          }
        };
      }
    },
  },
};
</script>
<style scoped>
.social-title {
  font-weight: 400;
  font-size: 13px;
}
.button-social {
  font-size: 8pt !important;
  font-weight: 500;
  margin: 0 0.5rem;
  padding: 10px !important;
  min-width: unset !important;
  box-sizing: border-box;
}

@media screen and (max-width: 500px) {

  .button-container {
    flex-direction: column;
    gap: 15px;
  }
  .button-social {
    flex: 0 0 100%;
  }
}
</style>
